// 仅整理公开展示字段；不读取票额、原单、令牌或参与资格。
export function carnivalImageUrl(value) {
  const text = typeof value === 'string' ? value.trim() : '';
  if (!text || /[\\\u0000-\u0020\u007f]/.test(text)) return '';
  if (/^\/(?![\/\\])/.test(text)) return text;
  try {
    const url = new URL(text);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password ? url.href : '';
  } catch { return ''; }
}
export function carnivalBackground(value) {
  const url = carnivalImageUrl(value);
  return url ? { backgroundImage: `url(${JSON.stringify(url)})`, backgroundPosition: 'top center', backgroundSize: 'cover' } : undefined;
}
export function carnivalVotePresentation(activity) {
  const value = activity?.carnivalPresentation;
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  return {
    objectName: typeof value.objectName === 'string' ? value.objectName : '',
    cardMainImageUrl: carnivalImageUrl(value.cardMainImageUrl),
    cardBackgroundImageUrl: carnivalImageUrl(value.cardBackgroundImageUrl)
  };
}
export function carnivalRecommendation(activity) {
  return {
    large: carnivalImageUrl(activity?.carnivalPresentation?.recommendLargeImageUrl),
    small: carnivalImageUrl(activity?.carnivalPresentation?.recommendSmallImageUrl)
  };
}
export function carnivalAdvertisements(activity, device) {
  const rows = activity?.carnivalPresentation?.advertisements;
  if (!Array.isArray(rows)) return [];
  return rows.flatMap((row, index) => {
    if (!row || typeof row !== 'object') return [];
    const image = carnivalImageUrl(row.imageUrl), smallImage = carnivalImageUrl(row.smallImageUrl);
    if (!image && !smallImage) return [];
    let href = '', external = false;
    if (Number(row.jumpType) === 2) {
      const id = typeof row.activityId === 'number' && !Number.isSafeInteger(row.activityId) ? '' : String(row.activityId ?? '');
      if (/^[1-9]\d{0,18}$/.test(id)) href = device === 'PC' ? `/activity/${id}` : `/pages/activity-detail/index?id=${id}`;
    } else if (Number(row.jumpType) === 1 && [2, 3].includes(Number(row.linkType))) {
      const target = carnivalImageUrl(row.linkUrl);
      // 站外链接必须是完整HTTP(S)地址；无链接及无效模式不恢复旧URL。
      if (Number(row.linkType) === 2 || /^https?:/.test(target)) href = target;
      external = Boolean(href) && Number(row.linkType) === 3;
    }
    return [{ key: `advertisement-${index}`, image: image || smallImage, smallImage, href, external,
      name: typeof row.activityName === 'string' ? row.activityName : '' }];
  });
}
